import { useModelLabel } from "@judo/i18n";
import type { Input, Switch as SwitchElement } from "@judo/model-api";
import { getInputTestId } from "@judo/test-ids";
import { FormControl, FormControlLabel, FormHelperText, Switch } from "@mui/material";

export interface SwitchComponentProps {
	element: SwitchElement | Input;
	readOnly?: boolean;
	value?: boolean;
	onChange?: (value: boolean) => void;
	error?: string;
	disabled?: boolean;
}

/**
 * Switch input component.
 */
export function SwitchComponent({ element, readOnly, value = false, onChange, error, disabled }: SwitchComponentProps) {
	const testId = getInputTestId(element);
	const { label: modelLabel } = useModelLabel(element);

	const label = `${modelLabel}${element.required ? " *" : ""}`;

	return (
		<FormControl error={!!error} disabled={disabled ?? element.disabled} required={element.required}>
			<FormControlLabel
				control={
					<Switch
						checked={value}
						onChange={(e) => onChange?.(e.target.checked)}
						disabled={readOnly ?? element.isReadOnly}
						data-testid={testId}
					/>
				}
				label={label}
			/>
			{error && <FormHelperText>{error}</FormHelperText>}
		</FormControl>
	);
}
